import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row, Spinner, Card } from 'react-bootstrap';
import { FaPlus, FaShoppingCart } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import ModalProductos from '../ModalProductos';
import ProductoCard from './ProductoCard';
import { useToast } from 'context/providers/ToastProvider';

const ProductosContainer = (
    {
        productosAgregados = [],
        setProductosAgregados,
        ordenDetallesProductos = []
    }


) => {

    const { token, setToken } = useToken();
    const ejecutadoRef = useRef(false);
    const [cargando, setCargando] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const { showErrorToast } = useToast();

    useEffect(() => {
        if (!ejecutadoRef.current && ordenDetallesProductos && Array.isArray(ordenDetallesProductos) && ordenDetallesProductos.length > 0) {
            ordenDetallesProductos.forEach((producto) => {
                agregarProducto(producto);
            });
            ejecutadoRef.current = true; // Marcar como ejecutado
        }
    }, [ordenDetallesProductos]);


    /**
     * Obtiene un producto por su ID
     */
    const ObtenerProductoPorID = async (idProducto, idProductoPrecio) => {
        setCargando(true)

        const response = await fetch("/api/contabilidad/facturas/FormularioFactura/ObtenerProductoPorID", // Cambia el endpoint si es necesario
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(idProducto)
            })
            .catch((error) => {

                showErrorToast('Hubo un problema con la petición Fetch: ' + error);
                console.log('Hubo un problema con la petición Fetch:', error);
            });

        if (response?.ok) {
            setCargando(false);
            console.log("==== OBTENER PRODUCTO ====");
            const data = await response.json();
            console.log("dataRF: ", data);

            if (data.iResponseType === 1) {
                setMostrarModal(false)

                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetallesPD:", ObjDetalles);

                const list = ObjDetalles.table2 || [];
                const selectedProductPrice = idProductoPrecio
                    ? list.find(p => p.idProductoPrecio === idProductoPrecio) || list[0]
                    : list[0];

                agregarProducto(selectedProductPrice);

            } else {

                showErrorToast(data.vMessage);
            }
        } else {
            setCargando(false);

            showErrorToast(response?.status + ' ' + response?.statusText);
            if (response?.status === 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    /**
     * Actualiza el campo de un producto específico usando idProducto
     */
    const actualizarCampo = (idUnica, campo, valor) => {
        setProductosAgregados((prevProductos) => {
            return prevProductos.map((producto) => {
                if (producto.idUnica !== idUnica) return producto; // No modificar otros productos

                // Actualizar el campo sin conversión
                const productoActualizado = {
                    ...producto,
                    [campo]: valor,
                };

                // Recalcular Importe, Impuestos y Total
                const importe = productoActualizado.dCantidad * productoActualizado.dPrecioUnitario;

                let nuevosImpuestos = [...(productoActualizado.impuestos || [])];

                // Si cambiamos cantidad, precio o los impuestos directamente, recalculamos los importes de los impuestos
                if (campo === 'dCantidad' || campo === 'dPrecioUnitario' || campo === 'impuestos') {
                    nuevosImpuestos = nuevosImpuestos.map(imp => {
                        if (imp.tipoFactor === "Tasa") {
                            return { ...imp, importe: importe * imp.tasaCuota };
                        } else if (imp.tipoFactor === "Cuota") {
                            return { ...imp, importe: imp.tasaCuota }; // Cuota es fija
                        }
                        return { ...imp, importe: 0 }; // Exento
                    });
                }

                productoActualizado.impuestos = nuevosImpuestos;

                const dTotalTraslados = nuevosImpuestos.filter(i => i.tipo === "Traslado").reduce((acc, i) => acc + i.importe, 0);
                const dTotalRetenciones = nuevosImpuestos.filter(i => i.tipo === "Retencion").reduce((acc, i) => acc + i.importe, 0);
                const dTotal = importe + dTotalTraslados - dTotalRetenciones;

                return {
                    ...productoActualizado,
                    dImporte: importe,
                    dTotalTraslados,
                    dTotalRetenciones,
                    dTotal
                };
            });
        });
    };

    /**
     * Agrega el producto a la tabla de productos
     */
    const agregarProducto = (producto) => {
        const dPrecioUnitario = producto.dPrecioUnitario ?? 0.0;
        // Usar la cantidad del producto si existe, sino usar 1 como predeterminada
        const dCantidad = producto.dCantidad ?? 1;

        // Calcular el importe primero (precio unitario * cantidad)
        const dImporte = dPrecioUnitario * dCantidad;

        let impuestosIniciales = [];
        let dTotalTraslados = 0;
        let dTotalRetenciones = 0;

        // Migración de datos legados si los tiene (Tasa/CuotaIVA)
        if (producto.vTipoFactorIVA && producto.vTipoFactorIVA !== "Exento") {
            const tasaCuota = producto.dTasaCuotaIVA ?? 0.0;
            const importeImpuesto = producto.vTipoFactorIVA === "Tasa" ? dImporte * tasaCuota : tasaCuota;

            impuestosIniciales.push({
                id: uuidv4(),
                tipo: "Traslado",
                impuesto: "002", // IVA por defecto
                tipoFactor: producto.vTipoFactorIVA,
                tasaCuota: tasaCuota,
                importe: importeImpuesto
            });
            dTotalTraslados += importeImpuesto;
        } else if (producto.vTipoFactorIVA === "Exento") {
            impuestosIniciales.push({
                id: uuidv4(),
                tipo: "Traslado",
                impuesto: "002", // IVA
                tipoFactor: "Exento",
                tasaCuota: 0,
                importe: 0
            });
        } else if (producto.impuestos && producto.impuestos.length > 0) {
            impuestosIniciales = [...producto.impuestos];
            dTotalTraslados = impuestosIniciales.filter(i => i.tipo === "Traslado").reduce((a, b) => a + b.importe, 0);
            dTotalRetenciones = impuestosIniciales.filter(i => i.tipo === "Retencion").reduce((a, b) => a + b.importe, 0);
        }

        // Calcular el total sumando el IVA al importe
        const dTotal = dImporte + dTotalTraslados - dTotalRetenciones;

        const idUnica = uuidv4();

        const productoProcesado = {
            idUnica, // ID única para el manejo interno
            idProducto: producto.idProducto,
            idProductoPrecio: producto.idProductoPrecio,
            vCodigoBarras: producto.vCodigoBarras ?? "",
            vNombreProducto: producto.vNombreProducto ?? "",
            dPrecioUnitario: dPrecioUnitario,
            dCantidad: dCantidad,
            dImporte: dImporte,
            vClaveUnidadSat: producto.vClaveUnidadSat ?? "",
            vCodigoProductoServicioSat: producto.vCodigoProductoServicioSat ?? "",
            impuestos: impuestosIniciales,
            dTotalTraslados,
            dTotalRetenciones,
            dTotal: dTotal, // Total con IVA incluido
            vImagenProducto_Base64: producto.vImagenProducto_Base64 || null,
            vImagenProducto_Name: producto.vImagenProducto_Name || null,
        };

        const file_jpg = producto.vImagenProducto_Base64
            ? base64ToFile(producto.vImagenProducto_Base64, producto.vImagenProducto_Name)
            : null;

        const imagenURL = file_jpg ? URL.createObjectURL(file_jpg) : null;

        // Agregar el producto a la lista
        setProductosAgregados((prevProductos) => [...prevProductos, { ...productoProcesado, imagenURL }]);
    };

    /**
     * Agrega un concepto vacío para ser llenado manualmente
     */
    const agregarConceptoLibre = () => {
        const idUnica = uuidv4();
        const nuevoConcepto = {
            idUnica,
            idProducto: null,
            idProductoPrecio: null,
            vCodigoBarras: "",
            vNombreProducto: "",
            dPrecioUnitario: 0.0,
            dCantidad: 1,
            vClaveUnidadSat: "",
            vCodigoProductoServicioSat: "",
            impuestos: [],
            dImporte: 0.0,
            dTotalTraslados: 0.0,
            dTotalRetenciones: 0.0,
            dTotal: 0.0,
            imagenURL: null
        };
        setProductosAgregados((prev) => [...prev, nuevoConcepto]);
    };

    /**
     * Elimina producto de la tabla de productos agregados y lo regresa a disponibles
     */
    const eliminarProducto = (index) => {

        // Filtrar los productos agregados para eliminar el seleccionado
        const nuevosProductosAgregados = productosAgregados.filter((_, i) => i !== index);
        setProductosAgregados(nuevosProductosAgregados);

    };

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        // Validar si no hay imagen
        if (!base64String) return null;

        try {
            // Extraer el contenido Base64 de manera segura
            const base64Data = base64String?.split(',')[1] || base64String;

            // Validar formato Base64
            if (!/^[A-Za-z0-9+/=]*$/.test(base64Data)) {
                console.error('Formato Base64 inválido');
                return null;
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const mimeType = base64String.split(';')[0]?.split(':')[1] || 'image/jpeg';

            return new File([new Blob([byteArray], { type: mimeType })], fileName, {
                type: mimeType,
                lastModified: Date.now()
            });

        } catch (error) {
            console.error('Error al convertir Base64 a File:', error);
            return null;
        }
    };



    // Calcular totales
    const calcularTotales = () => {
        const subtotal = productosAgregados.reduce((acc, prod) => acc + (prod.dImporte || 0), 0);
        const totalTraslados = productosAgregados.reduce((acc, prod) => acc + (prod.dTotalTraslados || 0), 0);
        const totalRetenciones = productosAgregados.reduce((acc, prod) => acc + (prod.dTotalRetenciones || 0), 0);
        const total = productosAgregados.reduce((acc, prod) => acc + (prod.dTotal || 0), 0);
        return { subtotal, totalTraslados, totalRetenciones, total };
    };

    const { subtotal, totalTraslados, totalRetenciones, total } = calcularTotales();


    return (
        <>
            {cargando &&
                (
                    <h6>
                        <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                    </h6>
                )}
            <Card className="factura-card mb-1 bg-white">
                <Card.Body className="factura-card-body">
                    <Row>
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h5 className="seccion-titulo mb-0">Productos de la Factura</h5>
                                <div>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        className="me-2"
                                        onClick={agregarConceptoLibre}
                                    >
                                        <FaPlus className="me-2" size={12} /> Agregar Concepto
                                    </Button>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => setMostrarModal(true)}
                                    >
                                        <FaPlus className="me-2" size={12} /> Agregar Producto
                                    </Button>
                                </div>
                            </div>

                            {/* Contenedor de productos */}
                            <div>
                                {productosAgregados.length === 0 ? (
                                    <div
                                        className="text-center py-5"
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            border: '2px dashed #d0d0d0',
                                        }}
                                    >
                                        <FaShoppingCart size={50} color="#d0d0d0" className="mb-3" />
                                        <h6 className="text-muted mb-1">No hay productos agregados</h6>
                                        <p className="text-muted small mb-0">Haz clic en "Agregar Producto" o "Agregar Concepto" para comenzar</p>
                                    </div>
                                ) : (
                                    <>
                                        {/* Lista de productos */}
                                        <div
                                            style={{
                                                maxHeight: "550px",
                                                overflowY: "auto",
                                                paddingRight: '8px',
                                            }}
                                            className="custom-scrollbar"
                                        >
                                            {productosAgregados.map((producto, index) => (
                                                <ProductoCard
                                                    key={producto.idUnica || index}
                                                    producto={producto}
                                                    index={index}
                                                    actualizarCampo={actualizarCampo}
                                                    eliminarProducto={eliminarProducto}
                                                />
                                            ))}
                                        </div>

                                        {/* Resumen de totales profesional */}
                                        <div className="mt-3 border border-200 rounded-3 overflow-hidden">
                                            <Row className="g-0 align-items-stretch">
                                                <Col xs={6} md={3}>
                                                    <div className="p-3 text-800">
                                                        <p className="mb-1 small fw-medium text-500">Subtotal</p>
                                                        <h5 className="mb-0 fw-bold">
                                                            ${subtotal.toFixed(2)}
                                                        </h5>
                                                    </div>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <div className="p-3 text-800">
                                                        <p className="mb-1 small fw-medium text-500">Traslados</p>
                                                        <h5 className="mb-0 fw-bold text-success">
                                                            + ${totalTraslados.toFixed(2)}
                                                        </h5>
                                                    </div>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <div className="p-3 text-800">
                                                        <p className="mb-1 small fw-medium text-500">Retenciones</p>
                                                        <h5 className="mb-0 fw-bold text-danger">
                                                            - ${totalRetenciones.toFixed(2)}
                                                        </h5>
                                                    </div>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <div className="bg-primary text-white p-3 h-100 d-flex flex-column justify-content-center">
                                                        <p className="mb-1 small text-white-50 fw-medium">
                                                            Total
                                                        </p>
                                                        <h4 className="mb-0 text-white fw-bold">
                                                            ${total.toFixed(2)}
                                                        </h4>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Col>

                        {/* Estilos para el scrollbar */}
                        <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #009bdb;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #007a9e;
                }
            `}</style>

                        {
                            mostrarModal &&
                            <>
                                <ModalProductos
                                    mostrarModal={mostrarModal}
                                    setMostrarModal={setMostrarModal}
                                    ObtenerProductoPorID={ObtenerProductoPorID}
                                    agregarProducto={agregarProducto}
                                    productosAgregados={productosAgregados}
                                />
                            </>

                        }
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};


ProductosContainer.propTypes = {
    productosAgregados: PropTypes.array,
    ordenDetallesProductos: PropTypes.array,
    setProductosAgregados: PropTypes.func,
    setCargando: PropTypes.func
};

export default ProductosContainer;



